export default __webpack_public_path__ + "static/media/side right.58632dcf.png";